"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../../types");
const constants_1 = require("../../../elements/elements/Card/constants");
const font_1 = require("../../font");
const theme_1 = require("../../theme");
const genStyle_1 = require("../genStyle");
const styleSchema = {
    card: {
        height: (0, genStyle_1.genStyle)({ value: 380 }),
        width: (0, genStyle_1.genStyle)({ value: 290 }),
        borderRadius: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.borderRadius }),
    },
    border: {
        borderStyle: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.borderStyle }),
        borderColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.borderColor }),
        borderWidth: (0, genStyle_1.genStyle)({ value: 1 }),
    },
    icon: {
        height: (0, genStyle_1.genStyle)({ value: 40 }),
        width: (0, genStyle_1.genStyle)({ value: 40 }),
        borderRadius: (0, genStyle_1.genStyle)({ value: 100 }),
    },
    hover: {
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.focusedColor }),
    },
    sideA: {
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.primaryBackgroundColor }),
        alignItems: (0, genStyle_1.genStyle)({ value: 'center' }),
    },
    sideAIcon: {
        backgroundImage: (0, genStyle_1.genStyle)({ value: null }),
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.primaryColor }),
        color: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.lightTextColor }),
        iconsAlign: (0, genStyle_1.genStyle)({ value: types_1.IconsAlignEnum.leftUp }),
    },
    sideB: {
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.primaryBackgroundColor }),
        alignItems: (0, genStyle_1.genStyle)({ value: 'center' }),
    },
    sideBIcon: {
        backgroundImage: (0, genStyle_1.genStyle)({ value: null }),
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.primaryColor }),
        color: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.lightTextColor }),
        iconsAlign: (0, genStyle_1.genStyle)({ value: types_1.IconsAlignEnum.leftUp }),
    },
    effects: {
        boxShadow: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.boxShadow }),
    },
    animation: {
        type: (0, genStyle_1.genStyle)({ value: types_1.FlipMethodCardEnum.click }),
        cardFlip: (0, genStyle_1.genStyle)({ value: types_1.AnimationTypeCardEnum.diagonalFlip }),
    },
};
const fontSchema = Object.assign({}, font_1.FONT_SCHEMA_EMPTY);
exports.default = { [constants_1.TYPE]: { style: styleSchema, font: fontSchema, feedback: {} } };
